import React, { useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import UpgradeBanner from './UpgradeBanner';
import Wordmark from './Wordmark';

const NAV_ITEMS = [
  { to: '/dashboard', label: 'Dashboard', icon: '⊞' },
  { to: '/game/new', label: 'New Game', icon: '▶' },
  { to: '/lists', label: 'My Lists', icon: '≡' },
  { to: '/account', label: 'Account', icon: '⚙' },
];

export default function DashboardLayout({ children }) {
  const { teacher, logout } = useAuth();
  const navigate = useNavigate();
  const [hoveredNav, setHoveredNav] = useState(null);
  const [logoutHovered, setLogoutHovered] = useState(false);

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', fontFamily: 'system-ui, -apple-system, sans-serif' }}>
      <UpgradeBanner />
      <div style={{ display: 'flex', flex: 1 }}>

        {/* Sidebar */}
        <aside style={{
          width: '220px',
          minWidth: '220px',
          backgroundColor: 'var(--color-primary)',
          color: '#fff',
          display: 'flex',
          flexDirection: 'column',
          padding: '0',
          position: 'sticky',
          top: '0',
          height: '100vh',
          overflowY: 'auto',
        }}>
          {/* Logo / branding */}
          <div style={{
            padding: '24px 20px 20px',
            borderBottom: '1px solid rgba(255,255,255,0.08)',
            '--color-primary': '#fff',
          }}>
            <Wordmark style={{ fontSize: '20px' }} />
            {teacher?.classroom_name && (
              <div style={{ fontSize: '12px', color: 'rgba(255,255,255,0.45)', marginTop: '4px' }}>
                {teacher.classroom_name}
              </div>
            )}
          </div>

          {/* Nav */}
          <nav style={{ flex: 1, padding: '12px 0' }}>
            {NAV_ITEMS.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === '/dashboard'}
                onMouseEnter={() => setHoveredNav(item.to)}
                onMouseLeave={() => setHoveredNav(null)}
                style={({ isActive }) => ({
                  display: 'flex',
                  alignItems: 'center',
                  gap: '10px',
                  padding: '10px 20px',
                  color: isActive || hoveredNav === item.to ? '#fff' : 'rgba(255,255,255,0.55)',
                  backgroundColor: isActive
                    ? 'rgba(255,255,255,0.08)'
                    : hoveredNav === item.to
                    ? 'rgba(255,255,255,0.05)'
                    : 'transparent',
                  textDecoration: 'none',
                  fontSize: '14px',
                  fontWeight: isActive ? '600' : '400',
                  borderLeft: isActive ? '3px solid var(--color-accent)' : hoveredNav === item.to ? '3px solid rgba(255,255,255,0.35)' : '3px solid transparent',
                  transition: 'all 0.15s',
                })}
              >
                <span style={{ fontSize: '16px', width: '20px', textAlign: 'center' }}>{item.icon}</span>
                {item.label}
              </NavLink>
            ))}
          </nav>

          {/* Logout */}
          <div style={{ padding: '16px 20px', borderTop: '1px solid rgba(255,255,255,0.08)' }}>
            <button
              onClick={handleLogout}
              onMouseEnter={() => setLogoutHovered(true)}
              onMouseLeave={() => setLogoutHovered(false)}
              style={{
                width: '100%',
                padding: '8px 12px',
                backgroundColor: logoutHovered ? 'rgba(255,255,255,0.06)' : 'transparent',
                border: `1px solid ${logoutHovered ? 'rgba(255,255,255,0.3)' : 'rgba(255,255,255,0.15)'}`,
                borderRadius: '6px',
                color: logoutHovered ? 'rgba(255,255,255,0.85)' : 'rgba(255,255,255,0.55)',
                fontSize: '13px',
                cursor: 'pointer',
                textAlign: 'left',
                transition: 'all 0.15s',
              }}
            >
              Log out
            </button>
          </div>
        </aside>

        {/* Main content */}
        <main style={{ flex: 1, backgroundColor: 'var(--color-background)', padding: '32px' }}>
          {children}
        </main>
      </div>
    </div>
  );
}
